/*
 * Module for the Mass Exception Correction View
*/

rs.module("content/employer/reporting/maintenance/massexceptioncorrection",

    ["common/select-helper", "controls/components/event-banner"],

    function (selectHelper, eventBanner) {

        //
        // Initialize
        //
        function initialize(jsSelectors, cssClasses, backendUrls, transmittalBatchKey) {

            // unpack jsSelectors
            var form = $.js(jsSelectors.form);
            var recordTypeSelect = form.js(jsSelectors.recordTypeSelect);
            var fieldToUpdateSelect = form.js(jsSelectors.fieldToUpdateSelect);
            var currentValueSelect = form.js(jsSelectors.currentValueSelect);

            var changeToSelectFormGroup = form.js(jsSelectors.changeToSelectFormGroup);
            var changeToSelect = form.js(jsSelectors.changeToSelect);

            var changeToDateFormGroup = form.js(jsSelectors.changeToDateFormGroup);
            var changeToDate = form.js(jsSelectors.changeToDate);

            var changeToInputFormGroup = form.js(jsSelectors.changeToInputFormGroup);
            var changeToInput = form.js(jsSelectors.changeToInput);

            var fieldDataType = form.js(jsSelectors.fieldDataType);
            var removeValueCheckbox = form.js(jsSelectors.removeValueCheckbox);

            // On Record Type select changed, load Field Names and "Change To" options
            recordTypeSelect.change(function () {

                _clearErrors();

                // clear fields
                var fieldToUpdateSelectHelper = selectHelper.getHelper(fieldToUpdateSelect).clearOptions();
                selectHelper.getHelper(currentValueSelect).clearOptions();
                selectHelper.getHelper(changeToSelect).clearOptions();
                changeToDate.val(null);
                changeToInput.val(null);
                removeValueCheckbox.setChecked(false).change();

                // show Change To select by default
                changeToSelectFormGroup.toggleClass(cssClasses.hidden, false);
                changeToDateFormGroup.toggleClass(cssClasses.hidden, true);
                changeToInputFormGroup.toggleClass(cssClasses.hidden, true);

                // if record type is not null, load available fields to change
                if (recordTypeSelect.val() != "") {

                    form.js(jsSelectors.recordTypeSpinner).show();

                    $.get(
                        backendUrls.loadFieldNames,
                        {
                            recordType: $(this).val()
                        }

                    ).done(function (fieldNames) {

                        if (fieldNames.length > 0) {

                            // If there was at least one field name returned, get the "Change To" options for the first field in the list
                            _loadChangeToOptions(fieldNames[0].value, function () {

                                // We are using a callback on loadChangeToOptions() to populate the Field To Update drop down 
                                // because we want all of these drop downs to populate at the same time.
                                // If we used selectHelper.loadOptionsFrom to populate it, it would happen first and then the rest would fill in, which looked sloppy
                                fieldToUpdateSelectHelper.replaceOptions(fieldNames);

                                form.js(jsSelectors.recordTypeSpinner).hide();
                            });
                        }

                    }).fail(function () {
                        form.js(jsSelectors.recordTypeSpinner).hide();
                    });
                }
            });

            // On Field To Update select change, load "Change To" options
            fieldToUpdateSelect.change(function () {

                _clearErrors();

                // this event will get fired when the Record Type select changes, if that is the case then that spinner will be showing
                // in which case we don't want to show the spinner or call loadChangeToOptions()
                if (!form.js(jsSelectors.recordTypeSpinner).is(":visible")) {

                    form.js(jsSelectors.fieldToUpdateSpinner).show();

                    _loadChangeToOptions($(this).val(), function () {
                        form.js(jsSelectors.fieldToUpdateSpinner).hide();
                    });
                }
            });

            // Toggle "Change To" fields when remove value checkbox is changed
            removeValueCheckbox.change(function () {
                if ($(this).is(":checked")) {

                    selectHelper.getHelper(changeToSelect)
                        .addEmptyOption()
                        .selectIndex(0)
                        .setDisabled(true);

                    changeToSelect.prop('disabled', true);
                    changeToDate.val(null).prop('disabled', true);
                    changeToInput.val(null).prop('disabled', true);
                }
                else {
                    selectHelper.getHelper(changeToSelect)
                        .removeEmptyOption()
                        .setDisabled(false);

                    changeToSelect.prop('disabled', false);
                    changeToDate.prop('disabled', false);
                    changeToInput.prop('disabled', false);

                    _resetValidations();
                }
            });

            //
            // Load "Change To" options
            //
            function _loadChangeToOptions(fieldType, callBack) {

                // clear Current Value select
                selectHelper.getHelper(currentValueSelect).clearOptions();

                // clear each of the "Change To" fields
                var changeToSelectHelper = selectHelper.getHelper(changeToSelect).clearOptions();
                changeToDate.val(null);
                changeToInput.val(null);
                removeValueCheckbox.setChecked(false).change();

                $.get(
                    backendUrls.loadChangeToOptions,
                    {
                        transmittalBatchKey: transmittalBatchKey,
                        fieldType: fieldType
                    }

                ).done(function (result) {

                    selectHelper.getHelper(currentValueSelect).replaceOptions(result.currentValueOptions);

                    // initially hide each of the "Change To" form groups
                    changeToSelectFormGroup.toggleClass(cssClasses.hidden, true);
                    changeToDateFormGroup.toggleClass(cssClasses.hidden, true);
                    changeToInputFormGroup.toggleClass(cssClasses.hidden, true);

                    // Set the data type of the Change To field
                    fieldDataType.val(result.dataType);

                    // Show corresponding "Change To" field based on data type
                    if (result.dataType == "List") {

                        changeToSelectFormGroup.toggleClass(cssClasses.hidden, false);
                        changeToSelectHelper.replaceOptions(result.changeToOptions);
                    }
                    else if (result.dataType == "Date") {

                        changeToDateFormGroup.toggleClass(cssClasses.hidden, false);
                    }
                    else if (result.dataType == "Text") {

                        changeToInputFormGroup.toggleClass(cssClasses.hidden, false);
                    }

                    // optional call back if specified
                    if (callBack) {
                        callBack.call(null);
                    }

                }).fail(function () {

                    form.js(jsSelectors.recordTypeSpinner).hide();
                    form.js(jsSelectors.fieldToUpdateSpinner).hide();
                });
            }

            //
            // Clear event banner and field errors
            //
            function _clearErrors() {

                // clear event banner
                eventBanner.removeAllMessages();

                recordTypeSelect.clearErrors();
                fieldToUpdateSelect.clearErrors();
                currentValueSelect.clearErrors();

                changeToSelect.clearErrors();
                changeToDate.clearErrors();
                changeToInput.clearErrors();
            }

            ///
            /// Resets unobtrusive validations, which is required after enabling previously disabled fields.
            ///
            function _resetValidations() {

                $.validator.resetValidation(form);
            }
        }
        
        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);